// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__Tskty","large":"styles_large__YI6GH"};